import { useMutation } from "@apollo/client";
import { DELETE_CHAT } from "@chat/graphql/mutations/deleteChat";
import { FETCH_CHATS } from "@chat/graphql/queries/fetchChats";
import { useLastModifiedChat } from "@chat/hooks/useLastModifiedChat";
import { useDispatch } from "react-redux";
import { setSelectChat } from "@store/slices/chatSelection";

/**
 * Löscht einen Chat.
 *
 * Es wird davon ausgegangen, dass die Bestätigung davor abgefragt wird.
 * Wenn bereits andere Chats existieren, wird der zuletzt bearbeitete Chat ausgewählt (statt dem zu löschenden)
 */
export const useDeleteChat = (chatId: string) => {
    const dispatch = useDispatch();
    const lastModifiedChat = useLastModifiedChat(chatId);

    const [deleteChatMutation] = useMutation(DELETE_CHAT, {
        variables: { id: chatId },
        refetchQueries: [FETCH_CHATS],
        onCompleted: (data) => {
            dispatch(setSelectChat(lastModifiedChat?.id || ""));
        },
    });

    return () => {
        deleteChatMutation();
    };
};
